import { useCallback } from 'react';
import { setProperty } from 'shared/lib/setQueryProperty';
import type { Project } from '@/enteties/project/modal';
import { projectKeys } from '@/enteties/project/api/projects.query-key';
import { useQueryClient } from '@tanstack/react-query';
import {
  getProjectsSetterQueryData,
  updateArrayItem,
} from 'shared/lib/updateQueryArrayProp';

export const useProjectQuerySlice = (slug: string) => {
  const queryClient = useQueryClient();
  const setProjectProperty = useCallback(
    (propsToUpdate: Partial<Project>) => {
      setProperty<Project>(
        queryClient,
        projectKeys.project(slug),
        propsToUpdate
      );
    },
    [queryClient, slug]
  );

  const setProjectArrayProperty = useCallback(
    (
      matcherFunc: (project: Project) => boolean,
      propsToUpdate: Partial<Project>
    ) => {
      const setServicesData = getProjectsSetterQueryData(queryClient);
      updateArrayItem<Project>(setServicesData, matcherFunc, propsToUpdate);
    },
    [queryClient]
  );
  return { setProjectProperty, setProjectArrayProperty };
};
